<template>
  <div class="about">
    <!-- Header -->
    <div class="header glass-panel">
      <div class="back-btn" @click="goBack">
        <i class="back-icon"></i>
      </div>
      <div class="header-title">主播详情</div>
      <div class="header-right"></div>
    </div>

    <!-- Scrollable Content -->
    <div class="scroll-wrap">
      <!-- Media Area -->
      <div class="media-container">
        <img :src="msg.img" alt="主播照片" class="main-image" />
        <div class="image-gradient"></div>
      </div>

      <!-- Info Card -->
      <div class="info-card">
        <div class="info-header">
          <h2 class="name">{{ msg.name }}</h2>
          <div class="hot-badge"><i class="hot-icon"></i> 热度飙升</div>
        </div>
        
        <div class="stats-row">
          <div class="stat-item">
            <span class="stat-value">{{ msg.score ? msg.score.replace('助力积分：', '') : '100W+' }}</span>
            <span class="stat-label">总助力值</span>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item">
            <span class="stat-value">Top {{ msg.rank || '1' }}</span>
            <span class="stat-label">当前排名</span>
          </div>
        </div>

        <div class="section-title">详细介绍</div>
        <p class="description">{{ msg.text }}</p>
      </div>
    </div>

    <!-- Sticky Bottom Bar -->
    <div class="bottom-bar glass-panel">
      <!-- Status Toast (inline) -->
      <transition name="fade" mode="out-in">
        <div class="status-msg" :key="statusMessage" v-show="statusMessage">
          {{ statusMessage }}
        </div>
      </transition>

      <div class="form-container">
        <div class="input-wrapper" :class="{ 'focused': isFocused }">
          <input
            type="text"
            v-model="boosterName"
            placeholder="请输入您的姓名"
            class="name-input"
            @focus="isFocused = true"
            @blur="isFocused = false"
            @keyup.enter="zhuli"
          />
        </div>
        
        <button 
          class="action-btn" 
          @click="zhuli" 
          :disabled="isBoosting"
          :class="{ 'boosting': isBoosting }"
        >
          {{ isBoosting ? '处理中...' : '立即助力' }}
        </button>
      </div>
    </div>

    <!-- Success Modal/GIF -->
    <transition name="modal">
      <div v-if="showSuccessGif" class="success-overlay">
        <div class="success-card">
          <div class="gif-wrap">
            <img src="../assets/image/1.439be5dc.gif" alt="Success" class="success-gif" />
          </div>
          <h3 class="success-title">助力成功！</h3>
          <div class="success-receipt">
            <p class="receipt-text">
              姓名 <span class="highlight-name">{{ boosterName }}</span> 助力主播 <span class="highlight-name">{{ msg.name ? msg.name : "该主播" }}</span> 打榜成功。
            </p>
            <p class="receipt-note">请将本页面截屏后联系您的助手。</p>
          </div>
          <button class="close-btn" @click="showSuccessGif = false">完成</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
  data() {
    return {
      msg: {},
      boosterName: "",
      statusMessage: "",
      successMessage: "",
      isFocused: false,
      isBoosting: false,
      showSuccessGif: false,
    };
  },
  mounted() {
    try {
      const msg = JSON.parse(localStorage.getItem("item"));
      if (msg) {
        this.msg = msg;
      }
    } catch (e) {
      console.error("Failed to parse item", e);
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    zhuli() {
      if (!this.boosterName.trim()) {
        this.statusMessage = "提示：请输入姓名后即可助力";
        setTimeout(() => { this.statusMessage = ""; }, 2500);
        return;
      }
      
      if (this.isBoosting) return;
      
      this.isBoosting = true;
      let livestreamer = this.msg.name ? this.msg.name : "该主播";
      
      this.statusMessage = `正在连接服务器...`;
      
      setTimeout(() => {
        this.statusMessage = "";
        this.isBoosting = false;
        
        // --- 核心涨分逻辑 ---
        try {
          // 1. 解析当前分数数字 (从 "助力积分：99999" 中提取)
          let currentScoreStr = this.msg.score.replace(/[^\d]/g, '');
          let currentScore = parseInt(currentScoreStr) || 0;
          let newScore = currentScore + 1;
          
          // 2. 更新本地显示
          this.msg.score = `助力积分：${newScore}`;
          
          // 3. 同步到全局缓存 Images_v3
          const cachedImages = JSON.parse(localStorage.getItem("Images_v3"));
          if (cachedImages && Array.isArray(cachedImages)) {
            const index = cachedImages.findIndex(i => i.id === this.msg.id);
            if (index !== -1) {
              cachedImages[index].score = this.msg.score;
              localStorage.setItem("Images_v3", JSON.stringify(cachedImages));
              console.log(`Successfully updated score for ${this.msg.name} to ${newScore}`);
            }
          }
          
          // 4. 更新当前项缓存，防止刷新后变回旧分
          localStorage.setItem("item", JSON.stringify(this.msg));
          
        } catch (err) {
          console.error("Score update failed:", err);
        }
        // ------------------

        this.showSuccessGif = true;
      }, 1200);
    },
  },
};
</script>

<style lang="less" scoped>
.about {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-body);
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  z-index: 50;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  
  .back-btn {
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: rgba(0,0,0,0.04);
    cursor: pointer;
    
    .back-icon {
      width: 10px;
      height: 10px;
      border-top: 2px solid var(--text-main);
      border-left: 2px solid var(--text-main);
      transform: rotate(-45deg);
      margin-left: 4px;
    }
  }
  
  .header-title {
    font-size: 16px;
    font-weight: 700;
    color: var(--text-main);
  }
  
  .header-right {
    width: 32px; /* Balance flex */
  }
}

.scroll-wrap {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 140px; /* Space for bottom bar */
}

.media-container {
  width: 100%;
  height: 350px;
  position: relative;
  
  .main-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .image-gradient {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
    background: linear-gradient(to top, var(--bg-body), transparent);
  }
}

.info-card {
  margin: -30px 16px 0;
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  padding: 24px;
  position: relative;
  z-index: 2;
  box-shadow: var(--shadow-sm);
  
  .info-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    
    .name {
      font-size: 24px;
      font-weight: 800;
      color: var(--text-main);
      max-width: 70%;
    }
    
    .hot-badge {
      background: #fff0f0;
      color: var(--secondary);
      font-size: 11px;
      font-weight: 700;
      padding: 4px 10px;
      border-radius: 12px;
      display: flex;
      align-items: center;
    }
  }
  
  .stats-row {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #f8f9fc;
    border-radius: var(--radius-md);
    padding: 16px;
    margin-bottom: 24px;
    
    .stat-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      
      .stat-value {
        font-size: 18px;
        font-weight: 800;
        color: var(--primary);
        margin-bottom: 4px;
      }
      
      .stat-label {
        font-size: 11px;
        color: var(--text-secondary);
      }
    }
    
    .stat-divider {
      width: 1px;
      height: 30px;
      background: rgba(0,0,0,0.05);
    }
  }
  
  .section-title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 12px;
    color: var(--text-main);
  }
  
  .description {
    font-size: 14px;
    line-height: 1.7;
    color: var(--text-secondary);
    text-align: justify;
  }
}

.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px 20px 24px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 -4px 20px rgba(0,0,0,0.04);
  z-index: 40;
  
  .status-msg {
    text-align: center;
    font-size: 12px;
    color: var(--secondary);
    margin-bottom: 8px;
    font-weight: 600;
  }
  
  .form-container {
    display: flex;
    gap: 12px;
  }
  
  .input-wrapper {
    flex: 1;
    height: 48px;
    background: #f4f5f7;
    border-radius: 24px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    border: 1px solid transparent;
    transition: all 0.2s;
    
    &.focused {
      background: #fff;
      border-color: var(--primary);
      box-shadow: 0 0 0 3px rgba(186, 111, 230, 0.1);
    }
    
    .name-input {
      width: 100%;
      height: 100%;
      border: none;
      background: transparent;
      outline: none;
      font-size: 15px;
      color: var(--text-main);
      
      &::placeholder {
        color: var(--text-tertiary);
      }
    }
  }
  
  .action-btn {
    height: 48px;
    padding: 0 28px;
    border-radius: 24px;
    background: var(--primary-gradient);
    color: #fff;
    border: none;
    font-size: 15px;
    font-weight: 700;
    box-shadow: 0 6px 16px rgba(186, 111, 230, 0.25);
    cursor: pointer;
    transition: transform 0.1s;
    
    &:active {
      transform: scale(0.95);
    }
    
    &.boosting {
      opacity: 0.8;
      pointer-events: none;
    }
  }
}

/* Modal Overlay */
.success-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  backdrop-filter: blur(4px);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.success-card {
  background: #fff;
  border-radius: var(--radius-lg);
  padding: 32px 24px;
  width: 100%;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: var(--shadow-lg);
  text-align: center;
  
  .gif-wrap {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 20px;
    background: #f8f9fc;
    display: flex;
    justify-content: center;
    align-items: center;
    
    .success-gif {
      width: 120%;
      height: 120%;
      object-fit: cover;
    }
  }
  
  .success-title {
    font-size: 22px;
    font-weight: 800;
    color: var(--text-main);
    margin-bottom: 16px;
  }
  
  .success-receipt {
    background: #f8f9fc;
    border: 1px dashed #d1d5db;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 24px;
    width: 100%;
    
    .receipt-text {
      font-size: 15px;
      line-height: 1.6;
      color: var(--text-main);
      margin-bottom: 10px;
      text-align: left;
      
      .highlight-name {
        color: var(--primary);
        font-weight: 800;
        font-size: 16px;
        padding: 0 4px;
      }
    }
    
    .receipt-note {
      font-size: 13px;
      font-weight: 700;
      color: var(--secondary);
      background: #fff0f0;
      padding: 6px 10px;
      border-radius: 6px;
      display: inline-block;
    }
  }
  
  .close-btn {
    width: 100%;
    height: 44px;
    border-radius: 22px;
    background: #f4f5f7;
    color: var(--text-main);
    font-weight: 700;
    font-size: 15px;
    border: none;
    cursor: pointer;
    
    &:active {
      background: #e5e7eb;
    }
  }
}

/* Modal Transitions */
.modal-enter-active, .modal-leave-active {
  transition: all 0.3s ease;
}
.modal-enter {
  opacity: 0;
  .success-card {
    transform: scale(0.9) translateY(20px);
  }
}
.modal-leave-to {
  opacity: 0;
}
</style>